import React from 'react';
import {
  Box,
  Menu,
  MenuItem,
  Stack,
} from '@mui/material';
import { LinkNav } from '@marageti/z4-lib';
import { Link } from 'react-router-dom';
import { MainNavListProps, NavItem, UserMenuProps } from './types';

const navItemsMain: NavItem[] = [
  {
    label: 'requests',
    to: 'trip-requests',
  },
  {
    label: 'matches',
    to: 'trip-matches',
  },
  {
    to: 'partners',
  },
  {
    label: 'travelers',
    to: 'travelers',
  },
  {
    to: 'reviews',
  },
  {
    label: 'sales',
    to: 'sales',
  },
  {
    label: 'tickets',
    to: 'tickets',
  },
];

const navItemsMainMobile: NavItem[] = [...navItemsMain, {
  label: 'settings',
  to: 'settings',
}];

const navItemsUser: NavItem[] = [
  {
    label: 'My Profile',
    to: 'settings',
  },
  {
    label: 'Log Out',
    to: 'logout',
  },
];

const MainNavListDesktop = ({
  sx,
}: MainNavListProps) => (
  <Stack
    direction="row"
    spacing={8}
    component="ul"
    sx={{
      margin: 0,
      padding: 0,
      listStyle: 'none',
      ...sx,
    }}
  >
    {navItemsMain.map((item: NavItem) => (
      <Box
        key={`${item.to}${item.label}`}
        component="li"
      >
        <LinkNav
          activeStyle={{ opacity: 0.5 }}
          color="primary.contrastText"
          end
          sx={{
            '&:hover': { color: { mobile: 'inherit', desktop: 'secondary.main' } },
          }}
          to={item.to}
        >
          {item.label || item.to}
        </LinkNav>
      </Box>
    ))}
  </Stack>
);

const MainNavListMobile = () => (
  <Stack
    direction="column"
    spacing={8}
    component="ul"
    sx={{
      px: 0,
      py: 1,
      margin: 0,
      marginBottom: 8,
      listStyle: 'none',
    }}
  >
    {navItemsMainMobile.map((item: NavItem) => (
      <Box
        key={`${item.to}${item.label}`}
        component="li"
      >
        <LinkNav
          activeStyle={{ opacity: 0.5 }}
          color="primary.contrastText"
          end
          sx={{
            '&:hover': { color: { mobile: 'inherit', desktop: 'secondary.main' } },
          }}
          to={item.to}
        >
          {item.label || item.to}
        </LinkNav>
      </Box>
    ))}
  </Stack>
);

const UserNavListMobile = () => (
  <Stack
    direction="column"
    spacing={8}
    component="ul"
    sx={{
      padding: 0,
      paddingBottom: 8,
      margin: 0,
      listStyle: 'none',
    }}
  >
    {navItemsUser.map((item: NavItem) => (
      <Box
        key={`${item.to}${item.label}`}
        component="li"
      >
        <LinkNav
          key={`${item.to}${item.label}`}
          activeStyle={{ opacity: 0.5 }}
          color="primary.contrastText"
          end
          to={item.to}
          sx={{
            fontWeight: 500,
          }}
        >
          {item.label || item.to}
        </LinkNav>
      </Box>
    ))}
  </Stack>
);

const UserMenuDesktop = ({
  anchorEl,
  open,
  handleClose,
}: UserMenuProps) => (
  <Menu
    anchorEl={anchorEl}
    id="user-menu"
    open={open}
    onClick={handleClose}
    onClose={handleClose}
    PaperProps={{
      sx: {
        display: { mobile: 'none', desktop: 'block' },
      },
    }}
    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
  >
    {navItemsUser.map((item: NavItem) => (
      <MenuItem
        component={Link}
        key={`${item.to}${item.label}`}
        to={item.to}
      >
        {item.label || item.to}
      </MenuItem>
    ))}
  </Menu>
);

export {
  MainNavListDesktop, MainNavListMobile, UserNavListMobile, UserMenuDesktop,
};
